import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { routerReducer as router, routerMiddleware } from 'react-router-redux';
import { authReducer as auth, authMiddleware } from 'redux-implicit-oauth2';
import { identity } from 'ramda';
import { rootSaga, sagaMiddleware } from './saga';
import history from './history';
import dashboard from './Dashboard/reducer';

const initialState = {};

export default createStore(
  combineReducers({
    router,
    auth,
    dashboard,
  }),
  initialState,
  compose(
    applyMiddleware(routerMiddleware(history), authMiddleware, sagaMiddleware),
    window.devToolsExtension ? window.devToolsExtension() : identity,
  ),
);

sagaMiddleware.run(rootSaga);



// WEBPACK FOOTER //
// ./src/store.js